var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member_tabbar"},_vm._l((_vm.list),function(item){return _c('a',{key:("cur" + (item.name)),class:{'active': item.id == _vm.curTitleId},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeTitle(item)}}},[_vm._v(_vm._s(item.name)),_c('i')])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c4a4d96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/accnav.vue
// module id = null
// module chunks = 